import React, { useState } from 'react';
import { useTranslation } from '../Context/TranslationContext';

const AwardsAndDecorationsPage = () => {
  const { isTamil } = useTranslation();
  const [openId, setOpenId] = useState(null);

  const t = {
    pageTitle: isTamil ? "விருதுகள் & அலங்காரங்கள்" : "Awards & Decorations",
    pageSubtitle: isTamil ? "பாரத சாரணர் & சாரணியர் தமிழ்நாடு" : "Bharat Scouts and Guides Tamil Nadu"
  };

  // Each award has a title and a set of labelled blocks. A block is either a
  // paragraph (string) or a bullet list ({ list: [...] }), optionally with a heading.
  const awards = [
    {
      id: "ap-leadership",
      title: "Asia Pacific Adult Leadership Award",
      image: "/Images/asiapacific.png",
      blocks: [
        {
          heading: "Aim",
          body: [
            "To recognize achievement of leaders in the Organizations for the Asia Pacific Regional award.",
            "There are three types of awards offered by the Asia Pacific Region:",
            { list: [
              "Asia Pacific Leadership Award for Troop/Unit Leaders.",
              "Asia Pacific Leadership Award for District/State Commissioners.",
              "Asia Pacific Leadership Award for Service to Girl Guiding / Girl Scouting."
            ]}
          ]
        },
        {
          heading: "Description",
          body: [
            "Awards are presented annually after the preceding Asia Pacific Regional Committee meeting.",
            "A certificate and an award pin will be presented to the awardees. The pin may be worn in and out of uniform."
          ]
        },
        {
          heading: "Ways of Work",
          body: [
            "Applications to the awards are open to all members of Guide Wing.",
            "Each State Association may nominate:",
            { list: [
              "Not more than 10 candidates per year for the AP Leadership Award – Troop/Unit Leaders.",
              "Not more than 5 candidates per year for the AP Leadership Award – District/State leaders.",
              "Not more than 2 candidates per year for the AP Leadership Award for Service to Girl Guiding / Girl Scouting."
            ]},
            "An awardee can only be awarded once in a lifetime for each type of category.",
            "An awardee can only be awarded no more than one type of award in a year."
          ]
        }
      ]
    },
    {
      id: "service-stars",
      title: "Service Stars",
      image: "/Images/servicestar.png",
      blocks: [
        {
          body: [
            { list: [
              "Service Stars are awarded for each year of service of one kind.",
              "Service Stars are in metal only.",
              "Second and subsequent service stars shall bear the numbers 2, 3, 4, and so forth.",
              "The Service Star of a Cub or a Bulbul shall be on blue background with a six-pointed metal star in the centre. The Service Star of a Scout or Guide shall be on green background with a six-pointed metal star in the centre and the Service Star of a Rover or Ranger shall be on red background with a six-pointed metal star in the centre.",
              "The Service Star for a Scouter or Guider or a person who holds any non-executive or honorary rank shall be on green background with a six-pointed metal star in the centre.",
              "Length of service is reckoned from the date of first investiture in the case of a Cub or Bulbul, Scout or Guide, Rover or Ranger; in the case of a Scouter or Guider, length of service is to be counted from the commencement of the probationary period and in the case of other ranks from the date of appointment. Service of more than one kind performed at the same time shall be reckoned only for one star; when a year's service comprises different kinds of service, not performed at the same time, but for different periods, the service which is the longest shall be reckoned for the purpose of service star.",
              "Transfer shall not affect the length of service to be reckoned for the purpose of Service Star.",
              "Service with any recognised foreign Scout or Guide Association may be reckoned for the purpose of Service Star.",
              "It is optional to wear the Service Star.",
              "Cub, Scout, Rover and Scouter shall wear the Service Stars immediately above the left pocket.",
              "Bulbul, Guide, Ranger and Guider shall wear the Service Stars above the pocket not covered by the saree.",
              "A Scout or a Guide who has previously been a Cub or a Bulbul as the case may be, may continue to wear the Star with blue background and the appropriate figure inscribed to indicate his or her length of service as a Cub or a Bulbul, in addition to the Service Star of green background to show his or her length of service as a Scout or a Guide; likewise a Rover or a Ranger may, in addition to the Service Star with red background to show his or her length of service as a Rover or a Ranger, continue to wear the Service Star with the appropriate number inscribed to indicate the service as a Scout or a Guide or as a Cub or a Bulbul.",
              "A minimum number of Service Stars shall be worn to indicate the length of service of one kind. The Star may be changed each year with the appropriate number to show the length of service."
            ]}
          ]
        }
      ]
    },
    {
      id: "special-service-star",
      title: "Special Service Star",
      image: "/Images/specialservicestar.png",
      blocks: [
        {
          body: [
            { list: [
              "Special Service Star is awarded for service of 25 years and more; the Special Service Star is on yellow background with a six-pointed metal star in the centre with the figure 25 inscribed in the centre to indicate the length of service.",
              "Service Stars and the Special Service Stars are awarded by the State Chief Commissioner on the recommendation of the appropriate authority."
            ]}
          ]
        }
      ]
    },
    {
      id: "long-service-decoration",
      title: "Long Service Decoration",
      image: "/Images/longservice.png",
      blocks: [
        {
          body: [
            { list: [
              "Long Service Decoration is awarded to warranted members of the Movement who have rendered not less than 10 years of faithful and efficient service in any of the ranks herein mentioned namely; Group Scouter, Group Guider, and Commissioner of all ranks.",
              "10 years service need not be continuous nor need it be in the same rank; service as a Scout or a Guide, or in any capacity other than those mentioned above shall not count for the purpose of the said period of 10 years.",
              "Long Service Decoration is a medallion with a ring in blue colour with gold border; the inset is the Emblem of the Bharat Scouts and Guides; the words 'Bharat Scouts and Guides' are inscribed on the ring and the figure 10 or 15 or 20 as the case may be is inscribed at the bottom of the ring.",
              "Award may be renewed for each additional period of 5 years.",
              "Long Service Medallion shall be worn above the right pocket; Guiders and women Commissioners may wear the Medallion on the side not covered by the saree.",
              "Long Service Decoration is awarded by the State Chief Commissioner in consultation with the concerned State Commissioner and the State Executive Committee on the recommendation of the Local or the District or Divisional Association."
            ]}
          ]
        }
      ]
    },
    {
      id: "thanks-badge",
      title: "Thanks Badge",
      image: "/Images/thanks.png",
      blocks: [
        {
          body: [
            { list: [
              "Thanks Badge is awarded to the friends and well-wishers of the Movement other than active Scouts or Guides or Scouters or Guiders or any warranted members of the Movement, who have rendered special good service to the Movement.",
              "Thanks Badge is composed of the Bharat Scouts and Guides Emblem set in a circular frame with the word 'Thanks' inscribed at the top.",
              "Thanks Badge is awarded by the State Chief Commissioner in consultation with the concerned State Commissioner and the State Executive Committee on the recommendation of the District Chief Commissioner, the Local or the District or Divisional Association, Group Scouters and Guiders.",
              "Thanks Badge does not confer membership of the Association and it must not be worn on uniform."
            ]}
          ]
        }
      ]
    },
    {
      id: "gallantry",
      title: "Award for Gallantry",
      image: "/Images/gallantry.png",
      blocks: [
        {
          body: [
            { list: [
              "Award for Gallantry is made to the Scout or Guide, Scouter or Guider or a person who holds non-executive or honorary rank or to a Group in case of joint action.",
              "Award for Gallantry is made by the Chief National Commissioner suo moto or on the recommendation of the State Chief Commissioner in consultation with the concerned National Commissioner and the National Executive Committee.",
              "The State Chief Commissioner shall make the recommendation in consultation with the concerned State Commissioner and the State Executive Committee.",
              "The recommendation for the Award for Gallantry shall contain a full account of the event and the evidence of the eye-witnesses wherever available.",
              "The recommendation shall not specify any grade of Award."
            ]}
          ]
        },
        {
          heading: "Awards for Gallantry are:",
          body: [
            { list: [
              "A Bronze Medal with blue and green ribbon; this is the highest award for Gallantry and is granted for special heroism or extra-ordinary risk.",
              "A Silver Medal with green ribbon; this is awarded for Gallantry with considerable risk.",
              "A Gilt Medal with green ribbon; this is awarded for Gallantry of moderate risk.",
              "Bar to the above medals may be granted for additional acts of Gallantry.",
              "Certificate: in case of Gallantry which does not merit the medal or the Bar, a certificate may be granted.",
              "Letter of Commendation: in case of Gallantry which does not merit the Medal or the Bar or the Certificate, a Letter of Commendation may be granted."
            ]},
            "Medals are worn on uniform above the right pocket; in the case of women the medals are worn on the side not covered by saree; in case of a Group the medal may be pinned on the Group Flag."
          ]
        }
      ]
    },
    {
      id: "medal-of-merit",
      title: "Medal of Merit",
      image: "/Images/medalofmerit.png",
      blocks: [
        {
          body: [
            { list: [
              "Medal of Merit has the Bharat Scouts and Guides Emblem in golden colour within a white metal circle suspended with a green ribbon.",
              "Medal of Merit is awarded to both warranted and non-warranted ranks such as President, Vice-President, Chairman, Treasurer, Secretary, Joint Secretary and Assistant Secretary for active and meritorious service to the Movement in any one or all ranks for not less than 10 years.",
              "Medal of Merit is awarded by the State Chief Commissioner suo moto or on the recommendation of the concerned Assistant State Commissioner, the District Chief Commissioner and the District or the Local Association in consultation with the concerned State Commissioner and the State Executive Committee.",
              "A Cloth Emblem with the design in green colour is also issued.",
              "Medal of Merit or the cloth Emblem may be worn in mufti also."
            ]}
          ]
        },
        {
          heading: "Bar to the Medal of Merit",
          body: [
            "A Bar to the Medal of Merit may be awarded for not less than five years of additional service of similar character after the award of Medal of Merit."
          ]
        }
      ]
    },
    {
      id: "silver-star",
      title: "Silver Star",
      image: "/Images/silverstar.png",
      blocks: [
        {
          body: [
            { list: [
              "Silver Star is awarded to both warranted and non-warranted ranks such as President, Vice-President, Chairman, Treasurer, Secretary, Joint Secretary and Assistant Secretary for special distinguished and continuous service for 20 years and more in any one or all the ranks.",
              "Service as Cub or Scout or Rover or Bulbul or Guide or Ranger shall not count for the purpose of 20 years service.",
              "Award is issued with a certificate.",
              "Award is a five-pointed Star with the Bharat Scouts and Guides Emblem, suspended with a yellow ribbon.",
              "A cloth Emblem with the design in yellow colour is also issued.",
              "Award is made by the Chief National Commissioner suo moto or on the recommendation of the concerned National Commissioner and the National Executive Committee; the State Chief Commissioner shall make the recommendation suo moto or on the recommendation of the District or Divisional or the Local Association in consultation with the concerned State Commissioner and the State Executive Committee.",
              "Silver Star is worn on the uniform above the right pocket by men and on the side not covered with saree by women."
            ]}
          ]
        },
        {
          heading: "Bar to Silver Star",
          body: [
            "A Bar to Silver Star may be awarded for not less than 5 years of additional service of a similar character after the award of Silver Star."
          ]
        }
      ]
    },
    {
      id: "silver-elephant",
      title: "Silver Elephant",
      image: "/Images/silverelephant.png",
      blocks: [
        {
          body: [
            { list: [
              "Silver Elephant is the highest National Award and is awarded for service of most exceptional character to the Movement.",
              "The Award is made by the Chief National Commissioner suo moto or on the recommendation of the State Chief Commissioner in consultation with the concerned National Commissioner and the National Executive Committee; the State Chief Commissioner shall make the recommendation suo moto or on the recommendation of the District or Divisional or Local Association in consultation with the concerned State Commissioner and the State Executive Committee. When the award is made by the Chief National Commissioner suo moto in consultation with the concerned National Commissioner and the National Executive Committee, the Chief National Commissioner shall also consult the concerned State Chief Commissioner.",
              "The Award of Silver Elephant is suspended with a ribbon into which are woven three strands of blue, green and red colours to represent the three sections of the Scout and Guide Movement.",
              "A cloth emblem with the design in blue, green and red may be worn in mufti.",
              "The Award shall be worn on uniform on special occasions only."
            ]}
          ]
        }
      ]
    }
  ];

  const renderBody = (body) =>
    body.map((item, i) => {
      if (typeof item === 'string') {
        return (
          <p key={i} className="text-gray-700 leading-relaxed mb-3">
            {item}
          </p>
        );
      }
      return (
        <ul key={i} className="space-y-3 mb-4">
          {item.list.map((point, j) => (
            <li key={j} className="flex items-start">
              <span className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-600 mr-3" />
              <span className="text-gray-700 leading-relaxed">{point}</span>
            </li>
          ))}
        </ul>
      );
    });

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-blue-50 mt-16">
      <div className="pt-24 pb-12">
        {/* Header */}
        <div className="text-center mb-16 px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-blue-900 mb-6 tracking-tight">
            {t.pageTitle}
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6 rounded-full" />
          <p className="text-xl md:text-2xl text-blue-700 font-medium max-w-2xl mx-auto">
            {t.pageSubtitle}
          </p>
        </div>

        {/* Accordion of awards */}
        <div className="max-w-4xl mx-auto px-4 space-y-5">
          {awards.map((award) => {
            const isOpen = openId === award.id;
            return (
              <div
                key={award.id}
                className="bg-white rounded-2xl shadow-md overflow-hidden border border-blue-100"
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : award.id)}
                  className="w-full flex items-center justify-between text-left px-6 md:px-8 py-5 hover:bg-blue-50/60 transition-colors"
                >
                  <h2 className="text-xl md:text-2xl font-bold text-blue-900">
                    {award.title}
                  </h2>
                  <svg
                    className={`w-6 h-6 text-blue-600 flex-shrink-0 ml-4 transform transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {isOpen && (
                  <div className="px-6 md:px-8 pb-8 pt-2 border-t border-blue-50">
                    {award.image && (
                      <div className="flex justify-center my-6">
                        <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-2xl p-6 flex items-center justify-center">
                          <img
                            src={award.image}
                            alt={award.title}
                            className="max-h-64 object-contain"
                          />
                        </div>
                      </div>
                    )}
                    {award.blocks.map((block, idx) => (
                      <div key={idx} className="mb-6 last:mb-0">
                        {block.heading && (
                          <h3 className="text-lg font-semibold text-blue-700 mb-3 uppercase tracking-wide">
                            {block.heading}
                          </h3>
                        )}
                        {renderBody(block.body)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AwardsAndDecorationsPage;
